import { render } from "./promise_info.vue?vue&type=template&id=26375ec8&ts=true"
import script from "./promise_info.vue?vue&type=script&lang=ts"
export * from "./promise_info.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/mysystem_data_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__